import { Injectable } from '@angular/core';
import { BehaviorSubject }    from 'rxjs/BehaviorSubject';
import { yearEndChart, yearEndPerformance, timerSettings } from './game';

@Injectable()

export class GameComponentService {
  // // Observable string sources
  // private missionAnnouncedSource = new Subject<string>();
  // private missionConfirmedSource = new Subject<string>();

  // // Observable string streams
  // missionAnnounced$ = this.missionAnnouncedSource.asObservable();
  // missionConfirmed$ = this.missionConfirmedSource.asObservable();
  // // Service message commands
  // announceMission(mission: string) {
  //   this.missionAnnouncedSource.next(mission);
  // }
  // confirmMission(astronaut: string) {
  //   this.missionConfirmedSource.next(astronaut);
  // }
  constructor() {
    console.log("construct GCS");
  }
  // Observable string sources
  private gameOver = new BehaviorSubject<boolean>(false);
  private gameStarted = new BehaviorSubject<boolean>(false);
  private showFooter = new BehaviorSubject<boolean>(false);
  private footerOpen = new BehaviorSubject<boolean>(false);
  //private initTimerLength = new BehaviorSubject<number>(10);
  private timerSetting = new BehaviorSubject<timerSettings>({Length:0,From:0,To:100,Year:"Year 1"});
  private yearStarted = new BehaviorSubject<boolean>(false);
  private yearGameCompleted = new BehaviorSubject<boolean>(false);
  private footerGrid = new BehaviorSubject<yearEndChart[]>([]);
  private footerChartLegend = new BehaviorSubject<string[]>([]);
  private footerChartData = new BehaviorSubject<number[][]>([]);
  private footerPerfYours = new BehaviorSubject<yearEndPerformance>(null);
  private footerPerfBank = new BehaviorSubject<yearEndPerformance>(null);

  // Observable string streams
  GameOver$ = this.gameOver.asObservable();
  GameStarted$ = this.gameStarted.asObservable();
  YearStarted$ = this.yearStarted.asObservable();
  YearGameCompleted$ = this.yearGameCompleted.asObservable();
  Timer$ = this.timerSetting.asObservable();
  ShowFooter$ = this.showFooter.asObservable();
  FooterOpen$ = this.footerOpen.asObservable();
  FooterGrid$ = this.footerGrid.asObservable();
  FooterLegend$ = this.footerChartLegend.asObservable();
  FooterData$ = this.footerChartData.asObservable();
  PerfYours$ = this.footerPerfYours.asObservable();
  PerfBank$ = this.footerPerfBank.asObservable();
  
  //General shared functions
  public resetService() {
    console.log("gameComponent.service : resetService");
    this.gameOver.next(false);
    this.gameStarted.next(false);
    this.showFooter.next(false);
    this.footerOpen.next(false);
    this.timerSetting.next({Length:0,From:0,To:100,Year:"Year 1"});
    this.yearStarted.next(false);
    this.yearGameCompleted.next(false);
    this.footerGrid.next([]);
    this.footerChartLegend.next([]);
    this.footerChartData.next([]);
    this.footerPerfYours.next(null);
    this.footerPerfBank.next(null);    
  }


  public secondsToTime(time:number):string {
    return Math.floor(time/60) + ":" + ("00" +(time % 60)).toString().slice(-2);
  }


  // Service message commands
  public GameOver(isOver:boolean) {
    console.log("GCS GameOver " + isOver);
    this.gameOver.next(isOver);
  }
  public StartGame(isStarting:boolean) {
    console.log("GCS StartGame " + isStarting);
    this.gameStarted.next(isStarting);
  }
  public StartYear(isStarting:boolean) {
    console.log("GCS StartYear " + isStarting);
    //gameOver
    //console.log(this.gameOver.value);
    //if(!this.gameOver.value && this.gameStarted) this.yearStarted.next(isStarting);
    this.yearStarted.next(isStarting)
  }
  public YearGameCompleted(isComplete:boolean) {
    console.log("GCS YearCompleted " + isComplete);
    this.yearGameCompleted.next(isComplete);
  }
  public SetFooter(isVisible:boolean) {
    console.log("GCS SetFooter " + isVisible);
    this.showFooter.next(isVisible);
    if (!isVisible) {
      this.SetFooterOpen(false);
    }
  }  
  public SetFooterOpen(isOpen:boolean) {
    console.log("GCS SetFooterOpen " + isOpen);
    this.footerOpen.next(isOpen);
  }
  public SetFooterData(endChart:yearEndChart[], chartLegend:string[], chartData: number[][]) {
    console.log("GCS SetFooterData " + endChart);
    this.footerGrid.next(endChart);
    this.footerChartLegend.next(chartLegend);
    this.footerChartData.next(chartData);

    /*
    console.log("****  SetFooterData ******");
    console.log("**********");
    console.log(chartData);
    console.log("**********");
    console.log("**********");*/ 
  }
  public SetPerformance(yours:yearEndPerformance, banks:yearEndPerformance) {
    console.log("GCS SetPerformance " + yours);
    this.footerPerfYours.next(yours);
    this.footerPerfBank.next(banks);
  }

  public SetTimer(timer:timerSettings, ) {
    console.log("GCS SetTimer " + timer);
    this.timerSetting.next(timer);
  }



}


// WEBPACK FOOTER //
// ./src/app/game/gameComponent.service.ts